export enum ChallengeType {
  Course = 'COURSE',
  User = 'USER',
}
